module.exports = __webpack_public_path__ + "img/unifisa-parceiros-logo.7f7b7d75.png";